
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {numeric, required, requiredIf} from "vuelidate/lib/validators";
import {Component} from "vue-property-decorator";
import {CounterpartiesAddFormRequestType} from "@/form/finance/counterparties/CounterpartiesAddForm.types";
import {ICounterpartiesType, CounterpartiesTypeResponseType} from "@/entity/finance/counterparties/counterpartiesType.types";
import { fio, email, phone } from "@/utils/validators";

@Component
export default class CounterpartiesAddForm extends Form{
    @Validate(required, i18nText("Выберите тип"))
    type_id = 1;
    @Validate(required, i18nText("Введите название"))
    name = '';
    //@Validate(required, 'Введите ИНН')
    inn = null;
    //@Validate(required, 'Введите КПП')
    kpp = null;
    //@Validate(required, 'Введите контактное лицо')
    contact_person = '';
    @Validate(phone, i18nText("Введите корректный номер телефона"))
    phone = null;
    @Validate(email, i18nText("Введите корректный Email"))
    email = null;
    //@Validate(required, 'Введите адрес')
    address = null;
    //@Validate(required, 'Выберите комментарий')
    comment = null;
    salon_id = 0;
    types: ICounterpartiesType[] | null = [
        {id: 1, name: i18nText("ИП")},
        {id: 2, name: i18nText("Юридическое лицо")},
        {id: 3, name: i18nText("Физическое лицо")},
    ]
    getFormData(): CounterpartiesAddFormRequestType {
        return {
            type_id: this.type_id,
            name: this.name,
            inn: this.inn,
            kpp: this.kpp,
            contact_person: this.contact_person,
            phone: this.phone,
            email: this.email,
            address: this.address,
            comment: this.comment,
            salon_id: this.salon_id
        }
    }
    setFormData(types: ICounterpartiesType[], salon_id?: number | null): void {
        this.types = [];
        if(salon_id){
            this.salon_id = salon_id;
        }
        for (let i = 0; i < types.length; i++) {
            if(!this.type_id){
                this.type_id = types[i].id;
            }
            this.types.push(types[i]);
        }
    }
}
